import React from 'react';

/**
 * Rosato photo grid — a small editorial mosaic that lives between the
 * "Pochi. Lenti. Numerati." chapter and Raffaello's quote.
 *
 * Desktop: single row of 6 photos (1×6 grid).
 * Mobile:  compact 2×3 grid.
 *
 * No lightbox, no zoom — the grid is purely a visual pause.
 */
const PICS = [
  { slug: '07-glasses-shadow', alt: 'Bottiglia Lempole Rosato inclinata con calici e ombre lunghe', speed:  0.05 },
  { slug: '02-lifestyle-hand', alt: 'Un momento lento: bottiglia e calice tra le mani',              speed: -0.04 },
  { slug: '03-bougainvillea',  alt: 'Lempole tra i fiori di bougainvillea',                           speed:  0.06 },
  { slug: '04-cherry-blossom', alt: 'Bottiglia adagiata su fondo rosa con fiori di ciliegio',         speed: -0.05 },
  { slug: '05-petals-cascade', alt: 'Una cascata di petali intorno alla bottiglia Lempole',           speed:  0.04 },
  { slug: '08-beach-glass',    alt: 'Un pomeriggio di mare: calice di Lempole Rosato in spiaggia',    speed: -0.06 },
];

const src = (slug, heroSrc) => {
  if (slug === 'hero') return heroSrc;
  // Slugs served as WebP; the rest of the archive is still jpg.
  const webpSlugs = ['07-glasses-shadow', '08-beach-glass'];
  const ext = webpSlugs.includes(slug) ? 'webp' : 'jpg';
  return `${process.env.PUBLIC_URL}/bottle-gallery/${slug}.${ext}`;
};

export default function RosatoPhotoGrid({ heroSrc }) {
  return (
    <section
      className="rosato-photogrid"
      aria-label="Galleria fotografica del Rosato"
      data-testid="rosato-photogrid"
    >
      <div className="rosato-photogrid__track">
        {PICS.map((p) => (
          <figure
            key={p.slug}
            className="rosato-photogrid__cell"
            data-parallax-speed={p.speed}
          >
            <img
              src={src(p.slug, heroSrc)}
              alt={p.alt}
              loading="lazy"
              decoding="async"
            />
          </figure>
        ))}
      </div>
    </section>
  );
}
